<template>
  <div>
    <div ref="servicekleberList" v-if="!currentServicekleber">
      <div class="text-center mt-3 w-100">
        <button @click="showAddressList()" class="btn btn-primary w-75">
          <i class="fas fa-arrow-left"></i>&nbsp;Zurück (alle Adressen)
        </button>
      </div>
      <div class="formTableContainer mt-3 w-100 mx-auto">
        <h1>Adresse: {{ address.tib.name }}</h1>
        <table v-if="address.tib || address.data" class="formTable w-100">
          <tr>
            <td>{{ tp.name }}:</td>
            <td>
              <p v-if="!doEdit">{{ address.tib.name }}</p>
              <input
                v-show="doEdit"
                ref="nameInput"
                type="text"
                class="w-100"
                v-model="address.tib.name"
              />
            </td>
          </tr>
          <tr>
            <td>{{ tp.popupMessage }}:</td>
            <td>
              <markedarea v-if="doEdit" v-model="address.data.popupMessage" />
              <div
                class="md wkMessageInline"
                v-if="!doEdit && address.data.popupMessage"
                v-html="markedHtml(address.data.popupMessage)"
              ></div>
              <p class="help">{{ tp.popupMessageHelp }}</p>
            </td>
          </tr>
          <tr>
            <td>{{ tp.description }}:</td>
            <td>
              <markedarea v-if="doEdit" v-model="address.data.description" />
              <div
                v-if="!doEdit"
                class="md"
                style="display:block; background-color: #9acfea"
                v-html="markedHtml(address.data.description)"
              ></div>
            </td>
          </tr>
          <tr>
            <td>{{ tp.address }}:</td>
            <td v-if="!doEdit">{{ address.data.address }}</td>
            <td v-if="doEdit">
              <input type="text" class="w-100" v-model="address.data.address" />
            </td>
          </tr>
          <tr>
            <td>{{ tp.city }}:</td>
            <td v-if="!doEdit">{{ address.data.city }}</td>
            <td v-if="doEdit">
              <input type="text" class="w-100" v-model="address.data.city" />
            </td>
          </tr>
        </table>
      </div>
      <div v-if="!doEdit" class="row mx-auto mt-3">
        <button @click="editMode(true)" class="btn btn-outline-dark btn-block">
          <i class="fas fa-edit"></i>&nbsp;Bearbeiten
        </button>
      </div>
      <div v-if="doEdit" class="row mx-auto mt-3">
        <div class="col">
          <button
            @click="editMode(false)"
            class="btn btn-outline-dark btn-block"
          >
            <i class="far fa-times-circle"></i>&nbsp;Abbrechen
          </button>
        </div>
        <div class="col">
          <button @click="updateTib()" class="btn btn-outline-dark btn-block">
            <i class="far fa-save"></i>&nbsp;Speichern
          </button>
        </div>
      </div>
      <h2 class="mt-3">Servicekleber</h2>
      <div
        class="row mx-auto"
        v-for="(wk, index) in address.servicekleber"
        :key="index"
      >
        <servicekleberItem
          :servicekleberProperty="wk"
          @selectservicekleber="showServicekleber"
          @savejournalEntry="saveJournalEntry"
          :tp="tp"
        >
        </servicekleberItem>
      </div>
      <button
        @click="createServicekleber()"
        class="btn btn-outline-dark btn-block mt-3 mb-3"
      >
        <i class="fas fa-plus"></i> {{ tp.createNewServicekleber }}
      </button>

      <h2>{{ tp.tibs }}</h2>
      <div
        class="row mx-auto"
        v-for="(tib, index) in address.tibs"
        :key="index"
      >
        <tibDetails
          :tibModelProperty="tib"
          @tibdeleted="removeTib"
          :tp="tp"
          @error="error"
        ></tibDetails>
      </div>
    </div>

    <div class="mt-2" v-if="currentServicekleber != null">
      <servicekleberDetails
        ref="servicekleberDetails"
        :servicekleberProperty="currentServicekleber"
        :doEditProperty="false"
        @showaddress="showAddress"
        @tibTagChanged="tibTagChanged"
        v-on="$listeners"
        :newTibTagProperty="newTibTagProperty"
        :tp="tp"
      ></servicekleberDetails>
    </div>
  </div>
</template>

<script>
import { TT_URL } from "@/common/constants";
import axios from "axios";

import { markedHtml } from "@/common/utils";
import servicekleberItem from "@/components/ServiceKleberItem.vue";
import tibDetails from "@/components/TibDetails.vue";
import servicekleberDetails from "@/components/ServiceKleberDetails.vue";
import markedarea from "@/components/marked/MarkedArea.vue";
export default {
  name: "addressDetails",
  components: {
    servicekleberItem,
    tibDetails,
    servicekleberDetails,
    markedarea
  },
  data: function() {
    return {
      address: this.addressProperty,
      currentServicekleber: null,
      oldTibName: "",
      doEdit: false,
      markedHtml: markedHtml
    };
  },
  mounted() {
    this.address = this.addressProperty;
    this.currentServicekleber = this.currentServicekleberProperty;
    if (this.address.doEdit) {
      this.editMode(true);
      this.address.doEdit = false;
    }
  },
  watch: {
    addressProperty() {
      this.address = this.addressProperty;
      console.info("address changed!!! " + this.address.tib.name);
    },
    currentServicekleberProperty() {
      this.currentServicekleber = this.currentServicekleberProperty;
      if (this.currentServicekleber) {
        this.$emit("selectservicekleber", this.currentServicekleber);
      }
      console.info(
        "currentServicekleberProperty changed!!! " +
          (this.currentServicekleber
            ? this.currentServicekleber.tib.name
            : "null")
      );
    }
  },
  methods: {
    updateTib() {
      let self = this;
      this.address.tib.data = JSON.stringify(this.address.data);
      axios
        .post(TT_URL + "/api/rest/tibtix/updateTib", this.address.tib)
        .then(response => {
          console.info("address saved : " + response);
          this.doEdit = false;
        })
        .catch(function(error) {
          self.$emit("error", "An error has occurred." + "\n" + error);
        });
      console.info("tibupdated");
      this.$emit("tibupdated");
    },
    saveJournalEntry(journalEntry) {
      this.$emit("savejournalentry", journalEntry);
    },
    createServicekleber() {
      this.$emit("createservicekleber", this.address);
    },
    showAddressList() {
      if (this.doEdit) {
        this.editMode(false);
      }
      this.$emit("showaddresslist", this.address);
    },
    showAddress() {
      console.info("emit: selectaddress");
      this.$emit("selectaddress", this.address);
    },
    showServicekleber(servicekleber) {
      console.info("emit: selectservicekleber");
      this.$emit("selectservicekleber", servicekleber);
    },
    editMode(on) {
      this.doEdit = on;
      if (on) {
        this.oldTibName = this.address.tib.name;
        this.focusNameInput();
      } else {
        this.address.tib.name = this.oldTibName;
        this.address.data = JSON.parse(this.address.tib.data);
      }
    },
    removeTib(tibModel) {
      console.info("removeTib");
      var index = this.address.tibs.indexOf(tibModel);
      if (index > -1) {
        this.address.tibs.splice(index, 1);
      }
    },
    focusNameInput() {
      this.$nextTick(() => {
        this.$refs.nameInput.focus();
        this.$refs.nameInput.select();
      });
    },
    tibTagChanged() {
      this.$emit("tibTagChanged");
    },
    error(msg) {
      this.$emit("error", "An error has occurred." + "\n" + msg);
    }
  },
  props: {
    addressProperty: Object,
    currentServicekleberProperty: Object,
    newTibTagProperty: String,
    tp: Object
  }
};
</script>
